__turbopack_context__.v({
  "visuallyHidden": "Accessibility-module__phmBWq__visuallyHidden",
});
